<template>
  <div
    ref="bar"
    class="fixed top-0 z-[1000] h-1 w-screen origin-top-left scale-x-[--scaleX] bg-primary"
    :style="{ '--scaleX': progress }"
  />
</template>

<script lang="ts" setup>
const bar = templateRef<HTMLElement>("bar");
const { height } = useWindowSize();
const { y } = useWindowScroll();

const contentHeight = ref(0);

onMounted(() => {
  contentHeight.value = bar.value?.parentElement?.clientHeight ?? 0;
});

const progress = computed(() => {
  if (!contentHeight.value) return 0;

  return Math.min(y.value / (contentHeight.value - height.value), 1);
});
</script>
